import React from "react";
import { Box, Card, Icon, Typography } from "@bca/ui-library";

import { formatMoney } from "./formatMoney";

const SuccessfulBuyNow: React.FunctionComponent<{
  buyNowPrice: number;
  title: string;
}> = ({ buyNowPrice, title }) => {
  return (
    <Card
      width="100%"
      height="auto"
      marginX={0}
      marginY={[3, 7, 0]}
      paddingX={28}
      paddingY={28}
    >
      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        mb={2}
      >
        <Icon
          name="check-circle"
          weight="solid"
          color="secondary-green"
          height={24}
          width={24}
          mr={3}
        />
        <Typography variant="h6" color="secondary-green" m={0}>
          {title}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="flex-end"
        mb={2}
      >
        <Typography
          css={`
            font-size: 30px;
            font-weight: 500;
          `}
          m={0}
          mr={3}
        >
          {formatMoney(buyNowPrice)}
        </Typography>
        <Typography variant="body" color="grey-blue" m={0} mb="6px">
          Excl. Fees
        </Typography>
      </Box>
      <Typography variant="body" color="grey-blue" m={0}>
        Your purchase will show in MyBCA shortly, where you will be able to make
        a payment, book a delivery or arrange a collection.
      </Typography>
    </Card>
  );
};

export default SuccessfulBuyNow;
